import { Navigate, Outlet } from 'react-router';
import { useAuthStore } from '../../stores/authStore';

/**
 * Phase 27a — gates `/platform/*` routes on the `platform_admin` role.
 *
 * Sits inside the standard `ProtectedRoute` wrapper so the user must
 * already be authenticated. If they don't hold platform_admin, send
 * them home — keeps the surface invisible to merchants logging into
 * the same dashboard.
 *
 * The server enforces the same restriction independently via
 * `PlatformAdminGuard`; this client-side check is a UX courtesy that
 * avoids a 403 dance.
 */
export default function PlatformGuard() {
  const user = useAuthStore((s) => s.user);

  if (!user) {
    // ProtectedRoute should already redirect, but defensive fallback.
    return <Navigate to="/login" replace />;
  }

  if (!user.roles.includes('platform_admin')) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
